module.exports = __webpack_public_path__ + "img/chemistry.d91bbd4a.png";